/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_vipUserRelationship = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_vipUserRelationship">;
    readonly " $refType": "PdpRespContainer_vipUserRelationship";
};
export type PdpRespContainer_vipUserRelationship$data = PdpRespContainer_vipUserRelationship;
export type PdpRespContainer_vipUserRelationship$key = {
    readonly " $data"?: PdpRespContainer_vipUserRelationship$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_vipUserRelationship">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_vipUserRelationship",
      "args": null
    }
  ]
};
(node as any).hash = 'b3496aec22adf532daa3156b8e973f56';
export default node;
